import React, { Component } from 'react'
import FormConsultaCamionesCalados from './FormConsultaCamionesCalados'

class ConsultaCamionesCalados extends Component {
  render () {
    return (
      <div id='consulta-camiones-calados-container'>
        <FormConsultaCamionesCalados />
      </div>
    )
  }
}

export default ConsultaCamionesCalados
